import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { SelectiveButton, } from '../../ui';
import { StyledButtonsContainer } from './SelectiveButtonGroup.style';
export function SelectiveButtonGroup({ options, variant = 'default', size = 'Medium', onChange, }) {
    return (_jsx(StyledButtonsContainer, { children: options.map((option, index) => {
            const buttonProp = Object.assign(Object.assign({}, option), { variant,
                size,
                onChange });
            return (_createElement(SelectiveButton, Object.assign({}, buttonProp, { key: `selective-button-${option.label}-${index}` })));
        }) }));
}
//# sourceMappingURL=SelectiveButtonGroup.js.map